var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWrong = function SvgWrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B80303",
    d: "M9 2.813a6.187 6.187 0 1 0 0 12.374A6.187 6.187 0 0 0 9 2.813M3.83 3.829a7.312 7.312 0 1 1 10.34 10.342A7.312 7.312 0 0 1 3.83 3.829m3.272 3.273c.22-.22.576-.22.796 0L9 8.205l1.102-1.103a.562.562 0 1 1 .796.796L9.795 9l1.103 1.102a.562.562 0 1 1-.796.796L9 9.795l-1.102 1.103a.562.562 0 1 1-.796-.796L8.205 9 7.102 7.898a.563.563 0 0 1 0-.796"
  })));
};
export default SvgWrong;